var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeartBreak = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43.616,
    height: 43.616,
    viewBox: "0 0 43.616 43.616",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#ffb5a7;}.c{fill:#231f20;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fac3c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd8d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-320.039 -43.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(320.039 43.002)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 21.808,
    cy: 21.808,
    r: 21.808
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(328.968 54.56)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.73 0.732)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M346.23,304.019c-4.439-7.021-10.485-.331-11.088.367-.6-.7-6.649-7.388-11.088-.367-4.458,7.052,11.088,18.372,11.088,18.372S350.688,311.071,346.23,304.019Z",
    transform: "translate(-323.251 -300.838)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M331.38,319.351a.73.73,0,0,1-.431-.14c-.657-.479-16.045-11.81-11.275-19.354,1.38-2.182,3.062-3.362,5-3.507,2.922-.219,5.533,2.006,6.7,3.19,1.172-1.185,3.78-3.41,6.7-3.19,1.939.144,3.622,1.324,5,3.507h0c4.769,7.544-10.618,18.875-11.276,19.354A.729.729,0,0,1,331.38,319.351Zm-6.3-21.553c-.1,0-.2,0-.293.011-1.452.108-2.755,1.06-3.874,2.83-2.059,3.256.929,7.752,3.8,10.951a52.292,52.292,0,0,0,6.671,6.114,52.335,52.335,0,0,0,6.685-6.129c2.862-3.194,5.841-7.683,3.785-10.936-1.119-1.77-2.422-2.722-3.874-2.83-2.931-.22-5.732,2.925-6.042,3.284a.732.732,0,0,1-1.107,0C330.527,300.746,327.9,297.8,325.077,297.8Z",
    transform: "translate(-318.758 -296.335)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.848 3.548)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M387.267,337.085a.732.732,0,0,1-.7-.953l1.45-4.576-2.2-1.491a.731.731,0,0,1-.214-.987l2.64-4.327-2.1-.505a.732.732,0,0,1-.545-.859l.958-4.643a.731.731,0,0,1,1.433.3l-.815,3.949,2.391.574a.731.731,0,0,1,.453,1.092l-2.8,4.588,2.079,1.406a.732.732,0,0,1,.288.827l-1.615,5.1A.732.732,0,0,1,387.267,337.085Z",
    transform: "translate(-385.493 -318.16)"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeartBreak);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/heart_break.8407720331b8168ae2a61b5955931a5c.svg";